import React, { useContext } from "react";
import { ContentContext } from "context/Content";
import { QuestionMarkCircleIcon } from "@heroicons/react/outline";
import { useContextualHelp } from "hooks/Help";
import { useHistory } from "react-router-dom";
import { nonce } from "Utils";

function CachedBanner(props) {
    const { content, isCached, kvStore } = useContext(ContentContext);
    const contextualHelp = useContextualHelp();
    const history = useHistory();

    if (!content || !isCached) {
        return null;
    }
    return (
        <div className="mb-4 items-center rounded bg-green-600 px-4 py-2 text-white md:flex">
            <div className="text-center text-sm md:text-left">
                Looks like there are some unsaved changes. You can save your
                work to commit the changes, or
            </div>
            <div className="mt-6 flex flex-grow items-center justify-center space-x-4 md:mt-0 md:justify-end">
                <button
                    type="button"
                    className="flex items-center justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-green-600 shadow-sm  hover:bg-green-50"
                    onClick={() => {
                        kvStore.remove(content.uuid).then(() => {
                            history.push(
                                `/app/${content.type}/${
                                    content.uuid
                                }?n=${nonce()}`
                            );
                        });
                    }}
                >
                    Refresh from the server
                </button>
                <button
                    onClick={() => {
                        contextualHelp.showContextualHelp(
                            "/article/index.html#auto-saving"
                        );
                    }}
                >
                    <QuestionMarkCircleIcon
                        className="h-5 w-5"
                        title="More Information"
                    />
                </button>
            </div>
        </div>
    );
}

export default CachedBanner;
